import Logger from 'js-logger';

import { axiosAuthed } from '../../../shared/utils/setCommonHeaders';
import { fetchUserData } from '../../login/ducks/loginActions';

import {
  FETCH_ORG_DATA_START,
  FETCH_ORG_DATA_FULFILLED,
  FETCH_ORG_DATA_REJECTED,
  JOIN_ORG_START,
  JOIN_ORG_FULFILLED,
  JOIN_ORG_REJECTED,
  LOAD_NEW_ORG_START,
  LOAD_NEW_ORG_FULFILLED,
  LOAD_NEW_ORG_REJECTED,
} from './actionTypes';

export const fetchOrgData = (token) => (
  (dispatch) => {
    dispatch({ type: FETCH_ORG_DATA_START });
    // Split token into parts and parse payload
    try {
      const tokenParts = token.split('.');
      if (tokenParts.length !== 3) {
        throw new Error('Invalid JWT token format');
      }
      const payload = JSON.parse(Buffer.from(tokenParts[1], 'base64').toString());
      const { tokenProps } = payload;

      const accountData = {
        accountCode: tokenProps.accountCode,
        accountLogoUrl: tokenProps.accountLogoUrl,
        accountName: tokenProps.accountName,
        accountPrimaryColor: tokenProps.accountPrimaryColor,
      };

      Logger.info('Org data decoded from JWT token:', accountData);
      dispatch({
        type: FETCH_ORG_DATA_FULFILLED,
        payload: accountData,
      });
    } catch (error) {
      Logger.error('Failed to decode JWT token:', error);
      dispatch({
        type: FETCH_ORG_DATA_REJECTED,
        payload: 'Failed to decode org data from token',
      });
    }
  }
);

export const joinOrg = (accountCode) => (
  (dispatch) => {
    dispatch({ type: JOIN_ORG_START });
    return axiosAuthed.put(`/me/accounts/${accountCode}/join-account`)
      .then((response) => {
        const { data } = response.data;
        Logger.info('Successfully joined organization:', data);
        dispatch({
          type: JOIN_ORG_FULFILLED,
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        Logger.error('Failed to join organization:', error);
        dispatch({
          type: JOIN_ORG_REJECTED,
          payload: error.response?.headers?.message || 'Failed to join organization',
        });
        throw error;
      });
  }
);

export const loadNewOrg = (accountCode) => (
  (dispatch) => {
    dispatch({ type: LOAD_NEW_ORG_START });
    axiosAuthed.put(`/me/accounts/${accountCode}/current`)
      .then(() => {
        Logger.info('Successfully switched to account:', accountCode);
        dispatch({ type: LOAD_NEW_ORG_FULFILLED });
        dispatch(fetchUserData());
        // Clear URL params and redirect
        window.history.replaceState({}, document.title, '/workouts');
        window.location.href = '/workouts';
      })
      .catch((err) => {
        Logger.error('Failed to switch accounts:', err);
        dispatch({
          type: LOAD_NEW_ORG_REJECTED,
          payload: err.data,
        });
      });
  }
);
